module.exports = __webpack_public_path__ + "static/media/up.1bf3087c.svg";